module.exports = "/images/vendor/flag-icon-css/flags/4x3/es-ca.svg?e9062265c973b4ab42aa70eb66ea8957";